import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IEipJobsRequestModel, IProjectMasterViewModel, IEdrcJobsRequestModel, IEnableSimilarProjectViewModel } from 'src/app/ViewModel/ProjectMasterModel';
import { RestApiService } from '../rest-api.service';

@Injectable({ providedIn: "root" })
export class ProjectMasterService {

  private endPoints = {
    projectsList: 'ProjectMaster/GetProjectDetails',
    insertUpdateProject: 'ProjectMaster/InsertUpdateProjectDetails',
    InsertUpdateEnableSimilarProject :'ProjectMaster/InsertUpdateEnableSimilarProject',
    eipJobs:'ProjectMaster/GetEIPJobListDetails',
    edrcJobs:'ProjectMaster/GetEDRCJobDetails'

  }

  constructor(private restAPIService: RestApiService) { }

  /**
   * Get project details API
   * @param project_Id 50
   */
  public getProjects(project_Id?: number, Member_Id?: number): Observable<any> {
    let reqData = {
      'project_Id': project_Id,
      'Member_Id': Member_Id
    };
    return this.restAPIService.new_POST(this.endPoints.projectsList, reqData);
  }

  public insertUpdateProject(project: IProjectMasterViewModel): Observable<any> {
    return this.restAPIService.new_POST(this.endPoints.insertUpdateProject, project);
  }

  public getEipjobList(eipReq:IEipJobsRequestModel){
    return this.restAPIService.new_POST(this.endPoints.eipJobs, eipReq);
  }

  public getEDRCjobList(eipReq:IEdrcJobsRequestModel){
    return this.restAPIService.new_POST(this.endPoints.edrcJobs, eipReq);
  }
  public InsertUpdateEnableSimilarProject(project: IEnableSimilarProjectViewModel): Observable<any> {
    return this.restAPIService.new_POST(this.endPoints.InsertUpdateEnableSimilarProject, project);
  }
}
